"use client"

// React and Core Libraries
import * as React from "react";

// Next.js Libraries
import { ThemeProvider as NextThemesProvider } from "next-themes";

// Types
import { type ThemeProviderProps } from "next-themes/dist/types";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>
}
